<template>
  <Teleport to="body">
    <client-only>
      <div class="fixed left-0 top-0 z-inpage-modal" role="dialog">
        <transition name="fade4">
          <div v-if="shouldShowModal">
            <SearchExperiences :on-close="props.onClose" :should-show-modal="props.shouldShowModal" />
          </div>
        </transition>
      </div>
    </client-only>
  </Teleport>
</template>

<script lang="ts" setup>
import SearchExperiences from '@/components/organisms/SearchExperiences/SearchExperiences.vue';

interface Props {
  shouldShowModal: boolean;
  onClose: () => void; // モーダルを閉じる処理
}

const props = defineProps<Props>();
</script>
